<template>
  <header class="home-header">
    <section class="home-header__content">
      <figure class="home-header__logo">
        <img src="/images/logo.png" alt="Logo" />
      </figure>

      <div class="home-header__hgroup">
        <h1 class="home-header__banner">{{ $t('header.title') }}</h1>
        
        <RouterLink :to="{ name: 'home', hash: '#workshops' }" class="link -icon">
          {{ $t('qigong.explore') }}
          <svg-icon id="arrow" />
        </RouterLink>
      </div>
    </section>

    <figure class="home-header__image" />
  </header>
</template>

<script>
export default {
  name: 'HomeHeader',
  props: {
    lang: { type: String, default: 'en' }
  }
}
</script>
